
import Vue, { PropType } from 'vue';
import Api from '@/core/api';
import IconButton from '@/common/icon-button/IconButton.vue';

export default Vue.extend({
    components: {
        IconButton
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        isLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    },

    methods: {
        toggleSidebar() {
            this.api.customAction(null, 'sidebarToggle');
        }
    }
});
